module.exports = __webpack_public_path__ + "img/middle_14.f059f9d1.png";